import { gql } from "@/__generated__/gql";

export const STUDENT_QUERY = gql(`
  query Student($id: ID!, $organizationId: ID!, $profilePhotoSize: Int = 400) {
    node(id: $id) {
      ... on Student {
        id
        uuid
        majors {
          edges {
            node {
              name
              id
            }
          }
        }
        interests {
          edges {
            node {
              name
              id
            }
          }
        }
        socials {
          edges {
            node {
              handle
              platform {
                name
                baseUrl
                icon {
                  url(size: 100)
                }
              }
            }
          }
        }
        studentOrganizationStatus(organizationId: $organizationId) {
          assignedCounselor {
            id
            uuid
            firstName
            lastName
            name @client
            isDefaultCounselor(organizationId: $organizationId)
            isSuperCounselor(organizationId: $organizationId)
            role
          }
          bio
          cohortYear
          commitIndex
          commitIndexChangedOn
          commitPercentile
          commitScore
          crmId
          crmUrl
          email
          fafsaCompletionStatus
          name
          firstName
          funnelState
          funnelStateTransitionSummary {
            state
            date
          }
          goingStatus
          goingStatusChangedOn
          hasTakenRoommateQuiz
          highSchool
          joinType
          joinedOn
          lastActiveAt
          lastName
          liveEventsAttended
          location
          lookingForRoommate
          phoneNumber
          schoolsAdmittedTo
          schoolsFollowing
          studentType
          visitedCampus
          becameUninterestedOn
          inCommunity
          interested
          joinedOn
          rise {
            applyIndex
            applyScore
            behaviorPersona
            commitIndex
            commitIndexChangedOn
            commitScore
            lifestylePersona
            meltIndex
            meltScore
            roommatePersona
            yieldIndex
            yieldScore
          }
        }

        profilePhoto {
          id
          url(size: $profilePhotoSize)
        }
      }
    }
  }
`);
